import * as React from "react";
import { SVGProps } from "react";
const SvgTablet = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" width="1em" height="1em" fill="none" viewBox="0 0 32 32" {...props}>
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M25.5 14.5c-.8 0-1.5.7-1.5 1.5s.7 1.5 1.5 1.5S27 16.8 27 16s-.7-1.5-1.5-1.5ZM26 6H6c-2.2 0-4 1.8-4 4v12c0 2.2 1.8 4 4 4h20c2.2 0 4-1.8 4-4V10c0-2.2-1.8-4-4-4Zm-5 18H6c-1.1 0-2-.9-2-2V10c0-1.1.9-2 2-2h15v16Zm7-2c0 1.1-.9 2-2 2h-3V8h3c1.1 0 2 .9 2 2v12Z"
      clipRule="evenodd"
    />
  </svg>
);
export default SvgTablet;
